/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Directory_Submit_Enrich_SubmittedInputs */

const en_directory_submit_enrich_submitted = /** @type {(inputs: Directory_Submit_Enrich_SubmittedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submitted for review: '${i?.slug}'`)
};

const zh_directory_submit_enrich_submitted = /** @type {(inputs: Directory_Submit_Enrich_SubmittedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已提交审核：'${i?.slug}'`)
};

/**
* | output |
* | --- |
* | "Submitted for review: '{slug}'" |
*
* @param {Directory_Submit_Enrich_SubmittedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_submitted = /** @type {((inputs: Directory_Submit_Enrich_SubmittedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_SubmittedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_submitted(inputs)
	return zh_directory_submit_enrich_submitted(inputs)
});
export { directory_submit_enrich_submitted as "directory.submit.enrich.submitted" }